import { BaseModel } from "@/models/base.model"
import type { IBaseLocation } from "@/interfaces/api/base-location.interface"

export abstract class BaseLocation extends BaseModel implements IBaseLocation {
  latitude?: number | null
  longitude?: number | null
  address?: string | null

  protected constructor(baseLocation: IBaseLocation) {
    super(baseLocation)

    this.latitude = baseLocation.latitude
    this.longitude = baseLocation.longitude
    this.address = baseLocation.address
  }
}
